var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.308H26V26H0V23.308ZM20.6261 9.7884V22.1903H23.2959V9.7884H20.6261ZM14.6516 9.7884V22.1903H17.3215V9.7884H14.6516ZM8.67718 9.7884V22.1903H11.3483L11.347 9.7884H8.67718ZM2.7027 9.7884V22.1903H5.37381V9.7884H2.7027ZM26 5.87458V8.67091H0V5.87458L6.448 2.96112L12.9987 0L19.5494 2.96112L26 5.87458ZM14.2048 4.84206C14.2048 4.16743 13.6639 3.619 13 3.619C12.3361 3.619 11.7965 4.16746 11.7965 4.84206C11.7965 5.5154 12.3373 6.06254 13 6.06254C13.664 6.06254 14.2048 5.51537 14.2048 4.84206Z",
    fill: "#32589F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.0878835d46a848d06a5bb3a0ee925c4b.svg";
export { ForwardRef as ReactComponent };